function resolveCurrentScript(): HTMLScriptElement | null {
  const current = document.currentScript;
  if (current instanceof HTMLScriptElement) {
    return current;
  }

  const candidates = Array.from(document.getElementsByTagName("script"));
  for (let i = candidates.length - 1; i >= 0; i -= 1) {
    const script = candidates[i];
    const src = script.getAttribute("src") || "";
    if (src.includes("/widget/v1.js") || src.endsWith("v1.js")) {
      return script;
    }
  }

  return null;
}

type FrameStateMessage = {
  type: "saldi-widget:resize";
  open: boolean;
  width: number;
  height: number;
};

const currentScript = resolveCurrentScript();
if (!currentScript) {
  throw new Error("SALDI widget loader: script tag not found");
}

const siteId = currentScript.dataset.siteId || currentScript.dataset.botId || "saldi-main";
const widgetBase = currentScript.dataset.apiBase || new URL("..", currentScript.src).toString().replace(/\/$/, "");
const widgetOrigin = new URL(widgetBase).origin;
const title = currentScript.dataset.title || "";
const uiScale = currentScript.dataset.uiScale || "";
const uiScaleMin = currentScript.dataset.uiScaleMin || "";
const uiScaleMax = currentScript.dataset.uiScaleMax || "";
const uiScaleStep = currentScript.dataset.uiScaleStep || "";

const host = document.createElement("div");
host.id = "saldi-chat-widget-loader-host";
document.body.appendChild(host);

const iframe = document.createElement("iframe");
iframe.title = title || "SALDI Chat";
iframe.setAttribute("aria-label", title || "SALDI Chat");
iframe.setAttribute("sandbox", "allow-scripts allow-forms allow-same-origin");
iframe.setAttribute("scrolling", "no");
iframe.referrerPolicy = "strict-origin-when-cross-origin";
iframe.style.position = "fixed";
iframe.style.right = "16px";
iframe.style.bottom = "16px";
iframe.style.width = "84px";
iframe.style.height = "84px";
iframe.style.border = "0";
iframe.style.background = "transparent";
iframe.style.overflow = "hidden";
iframe.style.zIndex = "2147483000";
iframe.style.transition = "width .22s ease, height .22s ease, left .22s ease, right .22s ease, bottom .22s ease";

const query = new URLSearchParams({
  siteId
});
if (title) {
  query.set("title", title);
}
if (uiScale) {
  query.set("uiScale", uiScale);
}
if (uiScaleMin) {
  query.set("uiScaleMin", uiScaleMin);
}
if (uiScaleMax) {
  query.set("uiScaleMax", uiScaleMax);
}
if (uiScaleStep) {
  query.set("uiScaleStep", uiScaleStep);
}

iframe.src = `${widgetBase}/widget/frame?${query.toString()}`;
host.appendChild(iframe);

let lastFrameState: FrameStateMessage = {
  type: "saldi-widget:resize",
  open: false,
  width: 84,
  height: 84
};

function applyFrameState(frameState: FrameStateMessage): void {
  lastFrameState = frameState;
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const isMobile = viewportWidth <= 700;

  if (!frameState.open) {
    iframe.style.left = "auto";
    iframe.style.right = "16px";
    iframe.style.bottom = "16px";
    iframe.style.width = `${frameState.width}px`;
    iframe.style.height = `${frameState.height}px`;
    return;
  }

  if (isMobile) {
    iframe.style.left = "10px";
    iframe.style.right = "10px";
    iframe.style.bottom = "10px";
    iframe.style.width = `${Math.max(280, viewportWidth - 20)}px`;
    iframe.style.height = `${Math.max(420, Math.min(viewportHeight - 20, frameState.height))}px`;
    return;
  }

  iframe.style.left = "auto";
  iframe.style.right = "16px";
  iframe.style.bottom = "16px";
  iframe.style.width = `${Math.min(frameState.width, viewportWidth - 32)}px`;
  iframe.style.height = `${Math.min(frameState.height, viewportHeight - 32)}px`;
}

window.addEventListener("message", (event: MessageEvent) => {
  if (event.origin !== widgetOrigin || event.source !== iframe.contentWindow) {
    return;
  }

  const data = event.data as Partial<FrameStateMessage> | undefined;
  if (
    !data ||
    data.type !== "saldi-widget:resize" ||
    typeof data.open !== "boolean" ||
    typeof data.width !== "number" ||
    typeof data.height !== "number"
  ) {
    return;
  }

  applyFrameState({
    type: "saldi-widget:resize",
    open: data.open,
    width: Math.round(data.width),
    height: Math.round(data.height)
  });
});

window.addEventListener("resize", () => {
  applyFrameState(lastFrameState);
});

applyFrameState(lastFrameState);
